import { Info } from "lucide-react";

import { cn } from "utils";

export const ARCHIVED_BANNER_TEXT =
  "This event is archived. You can still read it, but registration is closed.";

/**
 * Says an archived event is archived, wherever it is read.
 *
 * `strip` runs the full width above a page that has its own shell: the
 * application rail is fixed to the left edge from the `lg` breakpoint, so the
 * strip keeps clear of it there. `block` sits inside a page's own column.
 * Info tokens only. The fill is a tint, not the flat info colour (a bright
 * slab in Dusk), so the words stay in the foreground colour in both themes.
 */
export function ArchivedBanner({
  variant = "block",
  className,
}: {
  variant?: "strip" | "block";
  className?: string;
}) {
  return (
    <div
      role="status"
      data-testid="archived-banner"
      className={cn(
        "border-status-info bg-status-info/15 text-foreground",
        variant === "strip"
          ? "border-b px-5 py-3 md:px-10 lg:pl-[calc(15rem+2.5rem)]"
          : "rounded-lg border px-4 py-3",
        className,
      )}
    >
      <p className="flex items-start gap-2 text-sm font-medium wrap-anywhere">
        <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <span>{ARCHIVED_BANNER_TEXT}</span>
      </p>
    </div>
  );
}
